import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { playbackEvents } from '../../video/Player/playbackEvents'

export const useGroupVideoSync = ({ initialSyncEnabled, refetchGroup }) => {
  const [videoPlaybackStatus, setVideoPlaybackStatus] = useState(null)

  const initialSyncComplete = useRef(false)

  const resyncVideo = useCallback(
    ({ forcePause, forceNewStatus } = {}) => {
      refetchGroup().then((updatedGroupWatch) => {
        const { playback } = updatedGroupWatch || {}

        // this means the video has only just started, or the first playback change is too recent.
        if (playback?.seekTime && (forceNewStatus || !videoPlaybackStatus)) {
          setVideoPlaybackStatus({
            playing:
              !forcePause &&
              [playbackEvents.PLAY, playbackEvents.SKIP_PLAY].includes(playback.status),
            seekTime: playback.seekTime,
          })
        }
        initialSyncComplete.current = true
      })
    },
    [refetchGroup, videoPlaybackStatus],
  )

  // Initial synchronisation
  useEffect(() => {
    if (!initialSyncComplete.current && initialSyncEnabled) {
      resyncVideo()
    }
  }, [videoPlaybackStatus, initialSyncEnabled, resyncVideo])

  const externalHandlers = useMemo(
    () => ({
      initialSyncComplete: () => initialSyncComplete.current,
      resyncVideo: () => initialSyncComplete.current && resyncVideo({ forceNewStatus: true }),
      resyncVideoAndPause: () =>
        initialSyncComplete.current && resyncVideo({ forcePause: true, forceNewStatus: true }),
      onPlaybackStatusChange: (status) => {
        // prevents attempts to synchronise while intro is playing
        if (initialSyncEnabled) {
          setVideoPlaybackStatus(status)
        }
      },
    }),
    [initialSyncEnabled, resyncVideo],
  )

  return {
    ...externalHandlers,
    videoPlaybackStatus,
  }
}
